<script setup lang="ts">
useSeoMeta({
  title: 'Lab — Shakir Abdulrahim',
  ogTitle: 'Lab — Shakir Abdulrahim',
  description: 'Hardware experiments, IoT projects, and embedded engineering explorations.',
})

const { imageUrl } = useDirectusImage()

const { data: entries } = await useFetch('/api/lab', {
  default: () => [],
})
</script>

<template>
  <div class="py-24">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <p class="mb-4 text-sm font-medium tracking-widest text-[var(--color-amber)] uppercase">
        Lab
      </p>
      <h1 class="mb-6 text-4xl font-bold text-[var(--color-text)] sm:text-5xl">
        The Workbench
      </h1>
      <p class="mb-12 text-lg text-[var(--color-text-muted)]">
        Hardware experiments, embedded projects, and IoT explorations.
      </p>

      <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <NuxtLink
          v-for="entry in entries"
          :key="(entry as any).id"
          :to="`/lab/${(entry as any).slug}`"
          class="group overflow-hidden rounded-xl border border-[var(--color-card-border)] bg-[var(--color-card-bg)] transition-all duration-300 hover:border-[var(--color-amber)]/20 hover:shadow-[0_0_40px_rgba(250,185,91,0.05)]"
        >
          <div v-if="(entry as any).image" class="relative aspect-video overflow-hidden">
            <img
              :src="imageUrl((entry as any).image, { width: 640, quality: 80 })!"
              :alt="(entry as any).title"
              class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            >
          </div>
          <div class="p-6">
            <h3 class="mb-2 text-lg font-semibold text-[var(--color-text)] transition-colors group-hover:text-[var(--color-amber)]">
              {{ (entry as any).title }}
            </h3>
            <p class="mb-4 text-sm text-[var(--color-text-muted)]">
              {{ (entry as any).description }}
            </p>
            <div v-if="(entry as any).tags" class="flex flex-wrap gap-1.5">
              <span
                v-for="tag in (entry as any).tags"
                :key="tag"
                class="rounded-md border border-[var(--color-card-border)] bg-[var(--color-surface-hover)] px-2 py-0.5 text-xs text-[var(--color-text-muted)]"
              >
                {{ tag }}
              </span>
            </div>
          </div>
        </NuxtLink>
      </div>

      <p v-if="!entries?.length" class="mt-10 text-center text-[var(--color-text-muted)]">
        Lab experiments coming soon.
      </p>
    </div>
  </div>
</template>
